"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _envConstants = require("../../env-constants");
var _config = require("../config");
// const fetch = require('isomorphic-unfetch');
// const { ENV } = require('../../env-constants');
// const he = require('he');
// const { config } = require('../config');
// import he from 'he';
// import fetch from 'isomorphic-unfetch';

var baseUrl = _config.config.apiUrl;
var getWPResource = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(path) {
    var response, posts;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return fetch("".concat(baseUrl, "/wp-json/wp/v2/").concat(path));
        case 3:
          response = _context.sent;
          _context.next = 6;
          return response.json();
        case 6:
          posts = _context.sent;
          if (!(Array.isArray(posts) && posts.length)) {
            _context.next = 9;
            break;
          }
          return _context.abrupt("return", posts.map(parseWPJson));
        case 9:
          return _context.abrupt("return", null);
        case 12:
          _context.prev = 12;
          _context.t0 = _context["catch"](0);
          return _context.abrupt("return", _context.t0);
        case 15:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 12]]);
  }));
  return function getWPResource(_x) {
    return _ref.apply(this, arguments);
  };
}();

// this method is necessary to get blog posts together with total count of posts so we can determine how many pages of blogs we need for pagination
var getWPBlogs = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(path) {
    var response, posts;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return fetch("".concat(baseUrl, "/wp-json/wp/v2/").concat(path));
        case 3:
          response = _context2.sent;
          _context2.next = 6;
          return response.json();
        case 6:
          posts = _context2.sent;
          if (!(Array.isArray(posts) && posts.length)) {
            _context2.next = 9;
            break;
          }
          return _context2.abrupt("return", {
            posts: posts.map(parseWPJson),
            postsCount: response.headers.get('x-wp-total')
          });
        case 9:
          return _context2.abrupt("return", null);
        case 12:
          _context2.prev = 12;
          _context2.t0 = _context2["catch"](0);
          return _context2.abrupt("return", _context2.t0);
        case 15:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 12]]);
  }));
  return function getWPBlogs(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
var getWPFaq = /*#__PURE__*/function () {
  var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(path) {
    var response, posts;
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _context3.next = 3;
          return fetch("".concat(baseUrl, "/wp-json/wp/v2/").concat(path));
        case 3:
          response = _context3.sent;
          _context3.next = 6;
          return response.json();
        case 6:
          posts = _context3.sent;
          if (!(Array.isArray(posts) && posts.length)) {
            _context3.next = 9;
            break;
          }
          return _context3.abrupt("return", {
            posts: posts.map(parseWPJson),
            postsCount: response.headers.get('x-wp-total')
          });
        case 9:
          return _context3.abrupt("return", null);
        case 12:
          _context3.prev = 12;
          _context3.t0 = _context3["catch"](0);
          return _context3.abrupt("return", _context3.t0);
        case 15:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[0, 12]]);
  }));
  return function getWPFaq(_x3) {
    return _ref3.apply(this, arguments);
  };
}();
var unescapeFields = function unescapeFields(post) {
  // removing 'he' library
  // const fields = ['title', 'seo_title', 'excerpt'];
  // fields.forEach((f) => {
  //   if (post[f]) {
  //     if (typeof post[f].rendered === 'string') {
  //       post[f].rendered = he.unescape(post[f].rendered);
  //     } else if (typeof post[f] === 'string') {
  //       post[f] = he.unescape(post[f]);
  //     }
  //   }
  // });
  return post;
};
var assetizeUrls = function assetizeUrls(data) {
  var str = JSON.stringify(data);
  str = str.replace(/www\.theyachtweek\.com\/wp-content\/uploads/g, 'assets.theyachtweek.com/wp-content/uploads');
  return JSON.parse(str);
};
var parseWPJson = function parseWPJson(data) {
  return assetizeUrls(unescapeFields(data));
};
var getBlogCategoryId = function getBlogCategoryId() {
  return _envConstants.ENV.SITE === 'tsw' ? 2 : 3;
};
module.exports = {
  getWPResource: getWPResource,
  getWPBlogs: getWPBlogs,
  getWPFaq: getWPFaq,
  parseWPJson: parseWPJson,
  getBlogCategoryId: getBlogCategoryId
};